export default "__VITE_ASSET__CS1Q6pt4__"